module.exports = __webpack_public_path__ + "img/default7.986592cb.jpg";